export const activeChecked = (value, arr) => {
    return arr.find((el) => el === value) || false;
}